'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dropdownItem = require('./dropdown-item');

var _dropdownItem2 = _interopRequireDefault(_dropdownItem);

var _dropdownMenu = require('../../src/styles/dropdown-menu.scss');

var _dropdownMenu2 = _interopRequireDefault(_dropdownMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownMenu = function DropdownMenu(props) {
	var items = props.items,
	    parent = props.parent,
	    onItemClick = props.onItemClick,
	    toggleMobileSubmenu = props.toggleMobileSubmenu,
	    onItemMouseEnter = props.onItemMouseEnter,
	    isActive = props.isActive,
	    itemDisplayNameTransform = props.itemDisplayNameTransform,
	    itemChildrenTransform = props.itemChildrenTransform,
	    isSectionHeaderTransform = props.isSectionHeaderTransform,
	    ItemRenderer = props.ItemRenderer,
	    SectionHeaderRenderer = props.SectionHeaderRenderer,
	    mobile = props.mobile,
	    showExpandedDropdown = props.showExpandedDropdown,
	    specialistsAndPracticesItems = props.specialistsAndPracticesItems,
	    specialtiesItems = props.specialtiesItems,
	    conditionsAndProceduresItems = props.conditionsAndProceduresItems;


	var dropdownItems = function dropdownItems(items) {
		var itemOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		return items.map(function (item) {
			return _react2.default.createElement(_dropdownItem2.default, {
				item: item,
				parent: parent,
				onItemClick: onItemClick,
				toggleMobileSubmenu: toggleMobileSubmenu,
				onItemMouseEnter: onItemMouseEnter,
				isActive: isActive,
				itemDisplayNameTransform: itemDisplayNameTransform,
				itemChildrenTransform: itemChildrenTransform,
				isSectionHeaderTransform: isSectionHeaderTransform,
				ItemRenderer: ItemRenderer,
				SectionHeaderRenderer: SectionHeaderRenderer,
				itemOptions: itemOptions,
				mobile: mobile
			});
		});
	};

	if (showExpandedDropdown && (specialistsAndPracticesItems.length > 0 || specialtiesItems.length > 0 || conditionsAndProceduresItems.length > 0)) {
		return _react2.default.createElement(
			'div',
			{ className: [_dropdownMenu2.default["lists-wrapper"]].join(" ") },
			_react2.default.createElement(
				'div',
				{ className: _dropdownMenu2.default["list-title"] },
				'Specialties'
			),
			_react2.default.createElement(
				'div',
				{ className: _dropdownMenu2.default["list-title"] },
				'Conditions / Procedures'
			),
			_react2.default.createElement(
				'div',
				{ className: _dropdownMenu2.default["list-title"] },
				'Specialists / Clinics / Hospitals'
			),
			_react2.default.createElement(
				'div',
				{ className: _dropdownMenu2.default.listWrapper + ' ' + (parent ? _dropdownMenu2.default.submenu + ' ' + _dropdownMenu2.default.hideUntilRepositioned : '') },
				_react2.default.createElement(
					'ul',
					null,
					dropdownItems(specialtiesItems)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: _dropdownMenu2.default.listWrapper + ' ' + (parent ? _dropdownMenu2.default.submenu + ' ' + _dropdownMenu2.default.hideUntilRepositioned : '') },
				_react2.default.createElement(
					'ul',
					null,
					dropdownItems(conditionsAndProceduresItems)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: _dropdownMenu2.default.listWrapper + ' ' + (parent ? _dropdownMenu2.default.submenu + ' ' + _dropdownMenu2.default.hideUntilRepositioned : '') },
				_react2.default.createElement(
					'ul',
					null,
					dropdownItems(specialistsAndPracticesItems, { renderAsProfile: true })
				)
			)
		);
	} else {

		return _react2.default.createElement(
			'div',
			{ className: _dropdownMenu2.default.listWrapper + ' ' + (parent ? _dropdownMenu2.default.submenu + ' ' + _dropdownMenu2.default.hideUntilRepositioned : '') },
			_react2.default.createElement(
				'ul',
				null,
				dropdownItems(items)
			)
		);
	}
};

DropdownMenu.propTypes = {
	items: require('react').PropTypes.arrayOf(require('react').PropTypes.any).isRequired,
	parent: require('react').PropTypes.object,
	isActive: require('react').PropTypes.func,
	onItemClick: require('react').PropTypes.func,
	toggleMobileSubmenu: require('react').PropTypes.func,
	onItemMouseEnter: require('react').PropTypes.func,
	ItemRenderer: require('react').PropTypes.any,
	SectionHeaderRenderer: require('react').PropTypes.any,
	itemDisplayNameTransform: require('react').PropTypes.func,
	itemChildrenTransform: require('react').PropTypes.func,
	isSectionHeaderTransform: require('react').PropTypes.func,
	mobile: require('react').PropTypes.bool.isRequired
};
DropdownMenu.displayName = 'DropdownMenu';

DropdownMenu.defaultProps = {
	onItemClick: function onItemClick() {},
	onItemMouseEnter: function onItemMouseEnter() {},
	onItemMouseLeave: function onItemMouseLeave() {},
	itemDisplayNameTransform: function itemDisplayNameTransform(item) {
		return item.name;
	},
	itemChildrenTransform: function itemChildrenTransform(item) {
		return item.children;
	}
};
exports.default = DropdownMenu;